<template>
  <div class="flex items-start py-0.5">
    <checkbox v-if="showSkipToggle"
              :id="`checkbox-${path}`"
              :is-checked="!isKeySkipped"
              @update:isChecked="(checked) => $emit('toggle-key-skip', path, checked)"
              class="mr-2 flex-shrink-0 cursor-pointer"
    />
    <!-- keep the left gutter so nesting still indents when the skip toggle is hidden (Qdrant preview) -->
    <span v-else class="mr-2 flex-shrink-0 inline-block w-4" aria-hidden="true"/>
    <div class="flex-1">
      <span :class="isKeySkipped ? 'text-gray' : 'text-gray-dark'">{{ keyName }}: </span>
      <template v-if="isPrimitive">
        <span :class="isKeySkipped ? 'text-gray' : 'text-black'">{{ formatValue(value) }}</span>
      </template>
      <template v-else-if="isArray">
        <template v-if="value.length > 0">
          <div v-for="(item, index) in value" :key="index">
            <json-key-value
              :key-name="String(index)"
              :value="item"
              :path="`${path}[${index}]`"
              :vectorization-skip-tags="vectorizationSkipTags"
              :show-skip-toggle="showSkipToggle"
              @toggle-key-skip="handleToggleKeySkip"
            />
          </div>
        </template>
      </template>
      <template v-else-if="isObject">
        <template v-if="Object.keys(value).length > 0">
          <div v-for="(nestedValue, nestedKey) in value" :key="nestedKey">
            <json-key-value
              :key-name="nestedKey"
              :value="nestedValue"
              :path="`${path}.${nestedKey}`"
              :vectorization-skip-tags="vectorizationSkipTags"
              :show-skip-toggle="showSkipToggle"
              @toggle-key-skip="handleToggleKeySkip"
            />
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import Checkbox from '@/components/preview/Checkbox.vue'

export default {
  name: 'JsonKeyValue',
  components: { Checkbox },
  props: {
    keyName: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    path: {
      type: String,
      required: true
    },
    vectorizationSkipTags: {
      type: Array,
      default: () => []
    },
    // when false (Qdrant sources), render a read-only preview without the skip checkboxes — the
    // embed/payload/group_key field selection is the control instead of the skip deny-list.
    showSkipToggle: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isKeySkipped() {
      return this.vectorizationSkipTags?.includes(this.path) || false
    },
    isPrimitive() {
      return this.value === null ||
             this.value === undefined ||
             typeof this.value !== 'object' ||
             (this.value instanceof Date)
    },
    isArray() {
      return Array.isArray(this.value)
    },
    isObject() {
      return typeof this.value === 'object' &&
             this.value !== null &&
             !Array.isArray(this.value) &&
             !(this.value instanceof Date)
    }
  },
  methods: {
    formatValue(value) {
      if (value === null) return 'null'
      if (value === undefined) return 'undefined'
      if (typeof value === 'string') return value
      if (typeof value === 'boolean') return String(value)
      if (value instanceof Date) return value.toISOString()
      return String(value)
    },
    handleToggleKeySkip(path, checked) {
      this.$emit('toggle-key-skip', path, checked)
    }
  }
}
</script>
